(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-type-slimbanner/assets/javascripts/image-helpers.js') >= 0) return;  svs.modules.push('/components/content/banner-type-slimbanner/assets/javascripts/image-helpers.js'); 
(function() {
  'use strict';

  if (svs.isServer) {
    registerHelpers(require('hbs'), require('trinidad-core').core.config);
  } else {
    registerHelpers(Handlebars, { options: svs.core.config.data.svsconfig });
  }

  function isAbsoluteUrl(url) {
    return url && url.indexOf('http') === 0;
  }

  function registerHelpers(hbs, config) {
    hbs.registerHelper('getImageUrl', function(url) {
      url = isAbsoluteUrl(url) ? url : config.options.cdn2 + url;

      return url.replace('{width}', 640);
    });
  }
})();

 })(window);